import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Search: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['circle', { cx: '11', cy: '11', r: '8' }],
    ['path', { d: 'm21 21-4.3-4.3' }],
  ],
];

export default Search;
